import ClearIcon from "@mui/icons-material/Clear";
import { Button, Stack, TextField } from "@mui/material";

const inputSx = {
  width: { xs: "100%", sm: 165 },
  "& .MuiOutlinedInput-root": {
    height: 38,
    borderRadius: "33px",
    bgcolor: "neutral.100",
    color: "primary.900",
    fontSize: 13,
    fontWeight: 700,
    boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.5)",
    "& fieldset": { borderColor: "transparent" },
    "&:hover fieldset": { borderColor: "transparent" },
    "&.Mui-focused fieldset": { borderColor: "secondary.500" },
  },
  "& .MuiInputLabel-root": {
    color: "primary.900",
    fontSize: 12,
    fontWeight: 700,
  },
};

function DateFilter({ label, value, disabled, onChange }) {
  return (
    <TextField
      type="date"
      label={label}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      disabled={disabled}
      size="small"
      InputLabelProps={{ shrink: true }}
      inputProps={{ "aria-label": `Fecha ${label.toLowerCase()}` }}
      sx={inputSx}
    />
  );
}

export default function SalesImportFilters({
  dateFrom,
  dateTo,
  disabled = false,
  onChange,
  onClear,
}) {
  const hasFilters = Boolean(dateFrom || dateTo);

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={1.25}
      useFlexGap
      sx={{ alignItems: { xs: "stretch", sm: "center" }, flexWrap: "wrap" }}
    >
      <DateFilter
        label="Desde"
        value={dateFrom}
        disabled={disabled}
        onChange={(value) => onChange("dateFrom", value)}
      />
      <DateFilter
        label="Hasta"
        value={dateTo}
        disabled={disabled}
        onChange={(value) => onChange("dateTo", value)}
      />
      {hasFilters ? (
        <Button
          type="button"
          size="small"
          startIcon={<ClearIcon />}
          disabled={disabled}
          onClick={onClear}
          sx={{
            borderRadius: "16px",
            textTransform: "none",
            fontWeight: 700,
            fontSize: 12,
            color: "neutral.700",
          }}
        >
          Limpiar filtros
        </Button>
      ) : null}
    </Stack>
  );
}
